<template>
  <div class="">
    <div class="col-12">
      <div class="row">

        <div class="col-12">
          <b-form-checkbox class="d-inline-block mx-2" @change="storeConfigProductNameOptions"
                           v-model="productNameOptions.copyName"
                           name="check-button" switch>
            کپی نام محصول
          </b-form-checkbox>

          <b-form-checkbox class="d-inline-block mx-2" @change="storeConfigProductNameOptions"
                           v-model="productNameOptions.searchInGoogle"
                           name="check-button" switch>
            سرچ گوگل
          </b-form-checkbox>

          <b-form-checkbox class="d-inline-block mx-2" @change="storeConfigProductNameOptions"
                           v-model="productNameOptions.searchInGoogleImage"
                           name="check-button" switch>
            سرچ عکس گوگل
          </b-form-checkbox>
        </div>

      </div>
    </div>
    <b-table v-bind="tableAttributes" :fields="fields" :items="items">

      <template #cell(name)="data">
        <m-a class="text-dark text-decoration-none" target="_blank"
             :href="{ name: 'Product', params: { name: data.item.raw_link } }">
          {{ data.item.name }}
        </m-a>
        <div class="col-12">
          <b-icon v-if="productNameOptions.copyName" @click="copyProductName(data.item)" icon="files"
                  class="h5 p-0 m-0 mx-1"/>

          <a class="text-dark" v-if="productNameOptions.searchInGoogle" :href="productNameSearchInGoogle(data.item)"
             target="_blank">
            <b-icon icon="google"
                    class="h5 p-0 m-0 mx-1"/>
          </a>

          <a class="text-dark" v-if="productNameOptions.searchInGoogleImage"
             :href="productNameSearchInGoogleImage(data.item)" target="_blank">
            <b-icon
                icon="images"
                class="h5 p-0 m-0 mx-1"/>
          </a>

        </div>
      </template>

      <template #cell(thumbnail)="data">


        <product-image-manager :product="data.item"/>

      </template>


      <template #cell(price)="data">
        <update-product-general-info :product="data.item" mode="price"/>
        <update-product-general-info :product="data.item" mode="offer"/>
      </template>

      <template #cell(status)="data">
        <status-changer :item="data.item" item-type="product"/>
        <holoo-status :item="data.item" />
      </template>

      <template #cell(quantity)="data">
        <div v-if="data.item.variation == 0">
          <update-product-general-info :product="data.item" mode="quantity"/>
        </div>
        <div v-else>
          <span>-</span>
        </div>
      </template>

      <template #cell(order)="data">

        <update-product-general-info :product="data.item" mode="order"/>
      </template>

      <template #cell(brand)="data">
        <b-badge variant="info" class="text-wrap" v-if="data.item.is_digital==0 && data.item.brand">
          {{ data.item.brand.name }}
        </b-badge>
      </template>

      <template #cell(is_digital)="data">
        <b-badge variant="info" class="text-wrap">
          {{ data.item.is_digital == 0 ? 'فیزیکی' : 'دیجیتال' }}
        </b-badge>
      </template>

      <template #cell(category)="data">
      <span v-for="el in data.item.category">
        <b-badge variant="warning" class="text-wrap d-block mt-2">{{ el.name }}</b-badge>
      </span>
      </template>

      <template #cell(action)="data">
        <div class="" v-if="restoreState === true">
        <span
            @click="forceDeleteProduct(data.item)"
            class="h4 "
            v-b-tooltip.hover
            title="حذف دائمی">
        <b-icon icon="trash" class="m-3"/>
        </span>

          <span
              class="h4 pt-3"
              v-b-tooltip.hover
              title="بازگردانی"
              @click="restore(data.item)"
          >
        <b-icon
            icon="arrow-clockwise"
            class="m-3"

        ></b-icon>
      </span>

        </div>
        <div class="" v-else>

          <m-a target="_blank" class="text-dark" :href="{ name: 'EditProduct', params: { slug: data.item.raw_link } }">
         <span class="h4" v-b-tooltip.hover title="ویرایش">
            <b-icon icon="pencil" class="m-3 h4"/>
        </span>
          </m-a>

          <span @click="deleteProduct(data.item)" class="h4" v-b-tooltip.hover title="حذف">
            <b-icon icon="trash" class="m-3 h4"/>
        </span>

          <duplicate-item :item="data.item" item-type="product"/>


          <b-icon v-b-modal="`share-modal-${data.item.id}`" icon="share-fill" class="m-3 h4"/>

          <b-modal :id="`share-modal-${data.item.id}`" hide-footer>
            <div class="text-right" dir="rtl">
              <share-form :item="data.item" :shareable_id="data.item.id" shareable_type="product"/>
            </div>
          </b-modal>

        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import {tableAttributes} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/TableAttributes";
import {formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import UpdateProductGeneralInfo from "./UpdateProductGeneralInfo";
import StatusChanger from "../../genralComponents/StatusChanger";
import DuplicateItem from "../../genralComponents/DuplicateItem";
import ShareForm from "../Share/ShareForm.vue";
import ProductImageManager from "@/plugin/components/dashboard/product/ProductImageManager.vue";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";
import HolooStatus from "../Holoo/components/HolooStatus.vue";

export default {
  name: "tableItems",
  props: ["items", "restoreState"],
  components: {
    HolooStatus,
    ProductImageManager, ShareForm, UpdateProductGeneralInfo, StatusChanger, DuplicateItem,},
  data() {
    return {
      tableAttributes: {...tableAttributes, ...{responsive: true}},
      fields: [
        {key: "name", label: "نام"},
        {key: "thumbnail", label: "عکس"},
        {key: "price", label: "قیمت"},
        {key: "status", label: "وضعیت"},
        {key: "quantity", label: "تعداد"},
        {key: "order", label: "ترتیب"},
        {key: "brand", label: "برند"},
        {key: "is_digital", label: "نوع محصول"},
        {key: "category", label: "دسته بندی"},
        {key: "action", label: "#"},
      ],
      productNameOptions: {
        copyName: false,
        searchInGoogle: false,
        searchInGoogleImage: false
      }
    };
  },
  methods: {
    formatNumber,
    deleteProduct(item) {
      if (confirm('آیا از حذف این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/deleteProduct", item);
      }
    },
    restore(product) {
      if (confirm('آیا از بازگردانی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/restoreProduct", product);
      }
    },
    forceDeleteProduct(product) {
      if (confirm('آیا از حذف دائمی این محصول اطمینان دارید؟')) {
        this.$store.dispatch("Product/forceDeleteProduct", product);
      }
    },
    copyProductName(product) {
      navigator.clipboard.writeText(product.name).then(function () {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, function (err) {
        console.log('Copy Error => ', err)
      })
    },
    productNameSearchInGoogle(product) {
      const query = encodeURIComponent(product.name); // امن‌سازی ورودی برای URL
      const url = `https://www.google.com/search?q=${query}`;
      return url
    },
    productNameSearchInGoogleImage(product) {
      const query = encodeURIComponent(product.name); // امن‌سازی رشته برای URL
      const url = `https://www.google.com/search?tbm=isch&q=${query}`; // tbm=isch یعنی بخش Images
      return url
    },
    storeConfigProductNameOptions() {
      localStorage.setItem('productNameOptions', JSON.stringify(this.productNameOptions))
    },
    loadConfigProductNameOptions() {
      let value = localStorage.getItem('productNameOptions')
      if (value != undefined) {
        try {
          console.log(value)
          value = JSON.parse(value)
          this.productNameOptions = value
        } catch (e) {
          this.storeConfigProductNameOptions()
        }
      }
    },
  },
  mounted() {
    this.loadConfigProductNameOptions()
  }
};
</script>